import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_CREATE_MANUAL_DISBURSEMENT } from "../../../config/api";

export const submitManualPayout = createAsyncThunk(
  "submitManualPayout/create",
  async ({ data, callback, fail }, { dispatch, rejectWithValue }) => {
    try {
      const response = await Client({
        method: "POST",
        path: API_CREATE_MANUAL_DISBURSEMENT,
        data: data,
      });

      toast.success(response?.data?.message);
      callback();
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg || "Error processing payout ");
      if (fail) {
        fail();
      }
      return rejectWithValue(error.message);
    }
  }
);
